import React, { useMemo } from 'react';
import { Typography } from 'fronton-react';
import { styled } from 'linaria/react';
import { breakpoints } from 'media';
import { useSelector } from 'react-redux';
import { selectPageModelRootBanner } from 'store/pageModel';
import { selectWindowType } from 'store/pageStore';

const BannerImg = styled.img`
	width: 776px;
	${breakpoints.only.desktop} {
		width: 616px;
	}
	${breakpoints.to.desktop} {
		width: 100%;
	}
`;

const StyledLink = styled.a`
	width: fit-content;
`;

const BannerContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	margin: 40px 0;
`;

export const AnalizBanner = () => {
	const banner = useSelector(selectPageModelRootBanner);
	const windowSize = useSelector(selectWindowType);
	const imgSrc = useMemo(() => {
		switch (windowSize) {
			case 'desktop':
			case 'laptop':
				return banner?.photoLinkDesktop;
			case 'tablet':
				return banner?.photoLinkTablet;
			case 'mobile':
				return banner?.photoLinkMobile;
		}
	}, [banner?.photoLinkDesktop, banner?.photoLinkMobile, banner?.photoLinkTablet, windowSize]);

	/** Проверка что все поля заполнены */
	const isBannerDataApplied =
		banner && Object.keys(banner).length === Object.values(banner).filter(Boolean).length;

	if (!isBannerDataApplied) return null;
	return (
		<BannerContainer>
			<StyledLink href={banner.pathLink}>
				<BannerImg src={imgSrc} alt={banner.title} />
			</StyledLink>
			<Typography size="caption" variant="minor">
				* С полными условиями проведения акции можно ознакомиться перейдя по ссылке на
				баннере
			</Typography>
		</BannerContainer>
	);
};
